module.exports = __webpack_public_path__ + "static/media/plane.4a55c8d8.svg";